import { render, staticRenderFns } from "./TablaSimSolicitudes.vue?vue&type=template&id=0e0f8096&"
import script from "./TablaSimSolicitudes.vue?vue&type=script&lang=ts&"
export * from "./TablaSimSolicitudes.vue?vue&type=script&lang=ts&"
import style0 from "./TablaSimSolicitudes.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports